export const DEFAULT_PLACEHOLDER_HEIGHT = 156;
export const BIG_PLACEHOLDER_HEIGHT = 312;

export const DEFAULT_PLACEHOLDER_TEXT = 'No data available' as const;
